import React from 'react';
import { Flex, Box } from '@chakra-ui/react';

export const Error = ({ error }: any) => {
    return (
        <Flex
            height="100vh"
            width="100vw"
            justify="center"
            align="center"
            flexDir="column">
            <Box>
                <p>{`${(error as any)?.errorCode} - ${
                    (error as any)?.errorMessage
                }`}</p>
            </Box>
        </Flex>
    );
};
